// extracted by mini-css-extract-plugin
module.exports = {"appTypographyLink":"styles_appTypographyLink__6Iucc","underlineOnHover":"styles_underlineOnHover__rS4MZ"};